import { MEMBER_ID, StringTMap } from '@@types/common';
import Member from '@@types/Member';

import { OFFICE_HOURS_KEY } from '~/constants/member';
import MemberOfficeHours from '~/services/MemberOfficeHours';
import { userStore } from '~/stores/UserStore';
import { action, computed, observable } from 'mobx';
import { curry, map, pick, pipe } from 'ramda';

class OfficeHoursStore {
  map: StringTMap<MemberOfficeHours> = {};
  timeoutIds = {
    [OFFICE_HOURS_KEY.CHANNEL]: null,
  };

  @observable
  isInOfficeHoursMap: StringTMap<boolean> = {};

  @computed
  get isInOfficeHourMe() {
    return this.isInOfficeHoursMap[userStore.id] ?? true;
  }

  @computed
  get isInOfficeHourChannel() {
    return this.isInOfficeHoursMap[OFFICE_HOURS_KEY.CHANNEL] ?? true;
  }

  @action
  setIsInOfficeHour = (id: string, value: boolean) => {
    if (this.isInOfficeHoursMap[id] !== value) {
      this.isInOfficeHoursMap[id] = value;
    }
  };

  public isInOfficeHoursById = (memberId: MEMBER_ID): boolean => {
    return this.isInOfficeHoursMap[memberId] ?? true;
  };

  public isInOfficeHours = (member: Member): boolean => {
    return this.isInOfficeHoursById(member.id);
  };

  public revalidateIsInOfficeHours = (member: Member) => {
    const result = this.safeGetMemberOfficeHours(member.id).isInOfficeHour(member);
    this.setIsInOfficeHour(member.id, result);
  };

  public pickCurrentChannelMembers = (memberIds: MEMBER_ID[]) => {
    const pickMemberIds = memberIds.concat([userStore.id]);
    this.map = pick(pickMemberIds, this.map);
    this.isInOfficeHoursMap = pick(pickMemberIds, this.isInOfficeHoursMap);
  };

  private safeGetMemberOfficeHours = (memberId: MEMBER_ID) => {
    this.map[memberId] = this.map[memberId] || new MemberOfficeHours();
    return this.map[memberId];
  };

  public prepareForChangeTime = curry((callback: () => void, timeoutKey: string, memberIds: MEMBER_ID[]) => {
    window.clearTimeout(this.timeoutIds[timeoutKey]);
    const now = Date.now();
    const closedTime: number = pipe<any, any, any>(
      map((memberId: MEMBER_ID) => this.safeGetMemberOfficeHours(memberId).cacheValidTime),
      MemberOfficeHours.calcClosedTimestamp(now)
    )(memberIds);
    this.timeoutIds[timeoutKey] = window.setTimeout(() => {
      callback();
    }, closedTime - now);
  });
}

export default OfficeHoursStore;

export const officeHoursStore = new OfficeHoursStore();
